import { JobTaskStatusType } from '@/enum'
import type { IJobTask } from '@/interfaces/jobs/IJobTask'
import type { IJob } from '@/interfaces/jobs/IJob'
import type { IJobAssociatedAssetInfo } from '@/interfaces/jobs/IJobAssociatedAssetInfo'
import type { IJobTaskTemplate } from '@/interfaces/task-templates/IJobTaskTemplate'
import type { IJobEmployee } from '@/interfaces/jobs/IJobEmployee'
import type { IDocument } from '@/interfaces/IDocument'
import Base from '../Base'
import DocumentModel from '../DocumentModel'
import JobEmployee from './JobEmployee'
import Job from './Job'
import { JobTaskTemplate } from '../task-templates'
import JobAssociatedAssetInfo from './JobAssociatedAssetInfo'

class JobTask extends Base implements IJobTask {
  jobId: string
  job?: IJob
  number: number
  status: JobTaskStatusType
  dueAt?: string | null
  startedAt?: string
  completedAt?: string
  assetInfo?: IJobAssociatedAssetInfo
  data?: IJobTaskTemplate[]
  employees?: IJobEmployee[]
  documents?: IDocument[]
  notes?: string

  constructor(jobTask?: any) {
    super(jobTask)
    this.jobId = jobTask?.jobId
    this.job = jobTask?.job ? new Job(jobTask.job) : undefined
    this.number = jobTask?.number ?? 0
    this.status = jobTask?.status ?? JobTaskStatusType.OPEN
    this.dueAt = jobTask?.dueAt
    this.startedAt = jobTask?.startedAt
    this.completedAt = jobTask?.completedAt
    this.assetInfo = jobTask?.assetInfo ? new JobAssociatedAssetInfo(jobTask.assetInfo) : undefined
    this.data = jobTask?.data?.map((item: any) => new JobTaskTemplate(item))
    this.employees = jobTask?.employees?.map((emp: any) => new JobEmployee(emp))
    this.documents = jobTask?.documents?.map((doc: any) => new DocumentModel(doc))
    this.notes = jobTask?.notes
  }
}

export default JobTask
